const RadioIcon = ({ checked = false, size = 22, style = {} }) => {
  const src = checked
    ? "/images/icons/radio-button-checked.svg"
    : "/images/icons/radio-button-unchecked.svg";

  const alt = checked ? "Radio Checked" : "Radio Unchecked";

  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: size,
        height: size,
        ...style,
      }}
    />
  );
};

export default RadioIcon;
